export enum Z_INDEX_LAYERS {
  TOOLTIP_LAYER = -5,
  MODAL_LAYER = -4,
  DROPDOWN_LAYER = -3,
  OVERLAY_LAYER = -1,
  DEFAULT_LAYER = 0,
  ABOVE_LAYER = 1,
  MAX_LAYER = 10,
  BACKDROP_LAYER = 15,
  FLIGHT_DETAILS = 20,
  ABOVE_HEADER = 201,
}
